import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import CreateOrder from './pages/CreateOrder';
import ProductPricing from './pages/ProductPricing';
import Products from './pages/Products';
import CreateProduct from './pages/CreateProduct';
import ProductDetail from './pages/ProductDetail';
import Payments from './pages/Payments';
import WalletPayments from './pages/WalletPayments';
import LiveWhatsApp from './pages/LiveWhatsApp';
import VirtualBankAccounts from './pages/VirtualBankAccounts';
import Notifications from './pages/Notifications';
import AccessManagement from './pages/AccessManagement';
import Coupons from './pages/Coupons';
import CreateCoupon from './pages/CreateCoupon';
import CouponDetail from './pages/CouponDetail';
import PricingHistory from './pages/PricingHistory';
import PendingActions from './pages/PendingActions';
import GeneratedInvoices from './pages/GeneratedInvoices';
import InvoiceDashboard from './pages/InvoiceDashboard';
import GstDetails from './pages/GstDetails';
import PromoWallet from './pages/PromoWallet';
import SerialDCRRegister from './pages/SerialDCRRegister';
import WhatsAppPortal from './pages/WhatsAppPortal';
import HubManagement from './pages/HubManagement';
import DealsBanners from './pages/DealsBanners';
import B2BConfig from './pages/B2BConfig';
import B2BProducts from './pages/B2BProducts';
import B2BCoupons from './pages/B2BCoupons';
import CreateB2BCoupon from './pages/CreateB2BCoupon';
import B2BCouponDetail from './pages/B2BCouponDetail';
import BrandSupport from './pages/BrandSupport';
import Kits from './pages/Kits';
import CreateKit from './pages/CreateKit';
import KitDetail from './pages/KitDetail';
import Audiences from './pages/Audiences';
import AudienceBuilder from './pages/AudienceBuilder';
import AudienceDetail from './pages/AudienceDetail';
import CrmLeads from './pages/CrmLeads';
import CrmLeadDetail from './pages/CrmLeadDetail';
import CrmCalling from './pages/CrmCalling';
import CreateCrmLead from './pages/CreateCrmLead';
import CrmHistory from './pages/CrmHistory';
import CrmSettings from './pages/CrmSettings';
import CrmDashboard from './pages/CrmDashboard';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppRoutes() {
  const { user } = useAuth();
  const userData = user || {};

  return (
    <>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />\
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/kits/:id"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <KitDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/audiences"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <Audiences />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/audiences/create"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <AudienceBuilder />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/audiences/:id"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <AudienceDetail />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <Orders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders/create"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <CreateOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders/:orderId"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <OrderDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pricing"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin') {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <ProductPricing />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <Products />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/products/create"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CreateProduct />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/products/:productId"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <ProductDetail />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/brand-support"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <BrandSupport />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/kits"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <Kits />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/kits/create"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CreateKit />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/kits/edit/:kitId"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CreateKit isEdit />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/kits/view/:kitId"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <KitDetail />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/access"
              element= {
                <ProtectedRoute>
                  {(() => {
                      if (userData.role != 'superAdmin') {
                        console.log("condition false");
                        return <Navigate to="/orders" replace />;
                      }
                      return (
                        <>
                          <Navbar />
                          <AccessManagement />
                        </>
                      );
                    })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/payments"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("finance")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <Payments />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/wallet-payments"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("finance")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <WalletPayments />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/live-whatsapp"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <LiveWhatsApp />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && userData.role !== 'admin' && !userData.access?.includes('pricing')) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <Notifications />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/dba"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("finance") ) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <VirtualBankAccounts />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/coupons"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <Coupons />
                </ProtectedRoute>
              }
            />
            <Route
              path="/coupons/create"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <CreateCoupon />
                </ProtectedRoute>
              }
            />
            <Route
              path="/coupons/:couponId"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <CouponDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pricing-history"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("pricing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <PricingHistory />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/pending-actions"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <PendingActions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/generated-invoices"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("finance") && !userData.access?.includes("accounts")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <GeneratedInvoices />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/invoice-dashboard"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("accounts") && !userData.access?.includes("finance")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <InvoiceDashboard />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/gst"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("finance")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <GstDetails />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/promo-wallet"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin') {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <PromoWallet />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/serial-dcr"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <SerialDCRRegister />
                </ProtectedRoute>
              }
            />
            <Route
              path="/whatsapp"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && userData.role !== 'admin' && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <WhatsAppPortal />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/hub-management"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && userData.role !== 'admin') {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <HubManagement />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/deals-banners"
              element={
                <ProtectedRoute>
                  {(() => {
                    const userData = JSON.parse(localStorage.getItem('userData_30jan') || '{}');
                    if (userData.role !== 'superAdmin' && !userData.access?.includes('marketing')) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <DealsBanners />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/b2b-config"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("b2b") && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <B2BConfig />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/b2b-products"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("b2b") && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <B2BProducts />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/b2b-coupons"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("b2b") && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <B2BCoupons />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/b2b-coupons/create"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("b2b") && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CreateB2BCoupon />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/b2b-coupons/:couponId"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (userData.role !== 'superAdmin' && !userData.access?.includes("b2b") && !userData.access?.includes("marketing")) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <B2BCouponDetail />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/leads"
              element={
                <ProtectedRoute>
                  {(() => {
                    const allowed =
                      userData.role === 'superAdmin' ||
                      userData.role === 'admin' ||
                      userData.role === 'manager' ||
                      userData.access?.includes('crm');
                    if (!allowed) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CrmLeads />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/history"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (!['manager', 'admin', 'superAdmin'].includes(userData.role)) {
                      return <Navigate to="/crm/leads" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CrmHistory />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/settings"
              element={
                <ProtectedRoute>
                  {(() => {
                    if (!['manager', 'admin', 'superAdmin'].includes(userData.role)) {
                      return <Navigate to="/crm/leads" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CrmSettings />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/dashboard"
              element={
                <ProtectedRoute>
                  {(() => {
                    // Dashboard is manager / superAdmin only (spec §8).
                    if (!['manager', 'superAdmin'].includes(userData.role)) {
                      return <Navigate to="/crm/leads" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CrmDashboard />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/leads/create"
              element={
                <ProtectedRoute>
                  {(() => {
                    const allowed =
                      userData.role === 'superAdmin' ||
                      userData.role === 'admin' ||
                      userData.role === 'manager' ||
                      userData.access?.includes('crm');
                    if (!allowed) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CreateCrmLead />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/calling"
              element={
                <ProtectedRoute>
                  {(() => {
                    const allowed =
                      userData.role === 'superAdmin' ||
                      userData.role === 'admin' ||
                      userData.role === 'manager' ||
                      userData.access?.includes('crm');
                    if (!allowed) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CrmCalling />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/leads/:leadId"
              element={
                <ProtectedRoute>
                  {(() => {
                    const allowed =
                      userData.role === 'superAdmin' ||
                      userData.role === 'admin' ||
                      userData.role === 'manager' ||
                      userData.access?.includes('crm');
                    if (!allowed) {
                      return <Navigate to="/orders" replace />;
                    }
                    return (
                      <>
                        <Navbar />
                        <CrmLeadDetail />
                      </>
                    );
                  })()}
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/orders" replace />} />
          </Routes>
        </div>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
